
import { ColumnConfig, GenericTable } from './shared/GenericTable.';
import { useTranslation } from 'react-i18next';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { generateRandomNumbr } from '../utils/randomNumbers';
import { Button } from 'react-bootstrap';
import { Offer } from '../types/offerForm';
import { useOffers } from '../hooks/useOffers';



interface OfferListProps {
  offers: Offer[];
}

const OfferList: React.FC<OfferListProps> = ({ offers }: { offers: Offer[] }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { copyOffer , removeOffer } = useOffers()

    const [currentPage, setCurrentPage] = useState(1);
    //pagination
    const itemsPerPage = 16;
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const paginatedOffers = offers.slice(startIndex, endIndex);
    const totalPages = Math.ceil(offers.length / itemsPerPage);
    const isFirstPage = currentPage === 1;
    const isLastPage = currentPage === totalPages;
    const handlePageChange = (page: number) => {
      setCurrentPage(page);
    };

  const handleOnView = (offer: Offer) => {
    navigate(`/detail/${offer?.id}`, {state: {type: 'offer'}})
  }

  const handleOnEdit = (offer: Offer) => {
    navigate(`/edit/${offer?.id}`, { state: {type: 'offer'}})
  }

  const handleOnCopy = (offer: Offer) => {
    if(offer?.id){
      const id = generateRandomNumbr();
      const newInvoice = {
        ...offer,
        id: id,
      }
      copyOffer(offer.id as number, newInvoice as Offer )
    }
  }

  const handleOnDelete = (offer: Offer) => {
    removeOffer(offer?.id as number )
  }

  const invoiceColumns: ColumnConfig<Offer>[] = [
    { label: t('id'), accessor: 'id' },
    { label: t('offerNumber'), accessor: 'offerNumber' },
    { label: t('customerName'), accessor: 'to' },
    { label: t('amount'), accessor: 'total' },
  ];

  return (
    <>
      <GenericTable
        data={paginatedOffers}
        columns={invoiceColumns}
        onView={(invoice: Offer) => handleOnView(invoice)}
        onEdit={(invoice: Offer) => handleOnEdit(invoice)}
        onCopy={(invoice: Offer) => handleOnCopy(invoice)}
        onDelete={(invoice: Offer) => handleOnDelete(invoice)}
      />

      <div className="pagination">
              <Button
                className="pagination-button"
                variant='outline-secondary'
                onClick={() => handlePageChange(1)}
                disabled={isFirstPage}
              >
                {t('first')}
              </Button>
              <Button
                className="pagination-button"
                variant='outline-primary'
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={isFirstPage}
              >
                {t('back')}
              </Button>
              <Button
                className="pagination-button"
                variant='outline-primary'
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={isLastPage}
              >
                {t('next')}
              </Button>
              <Button
                className="pagination-button"
                variant='outline-secondary'
                onClick={() => handlePageChange(totalPages)}
                disabled={isLastPage}
              >
                {t('last')}
              </Button>
        </div>
    </>
    
    
  );
};
export default OfferList;
